module.exports = __webpack_public_path__ + "static/media/ic_caret_down.d884d768.svg";